import { usePdfGeneratorMutation } from '../features/authentication/pdfGeneratorApiSlice';
import { bytesToBase64 } from './pdfUtils';

const usePrintPdfGenerator = () => {
  const [pdfGenerator, { isLoading }] = usePdfGeneratorMutation();

  const printPDF = async (fileName, innerHTML, pageSize, isLandscape = false) => {
    const base64Encoded = bytesToBase64(new TextEncoder().encode(innerHTML));

    const options = {
      htmlContent: base64Encoded,
      OutputFileName: fileName,
      PageSize: pageSize,
      IsLandscape: isLandscape
    };

    try {
      const pdfBlob = await pdfGenerator(options).unwrap();
      const pdfUrl = URL.createObjectURL(pdfBlob);
      const link = document.createElement('a');
      link.href = pdfUrl;
      link.download = `${fileName}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(pdfUrl);
      return pdfBlob;
    } catch (error) {
      console.error(error);
    }
  };

  return { printPDF, isPdfGenerating: isLoading };
};

export default usePrintPdfGenerator;